import { AiFillFileText, AiFillFolder, AiFillHome  } from 'react-icons/ai'
import { FaMapSigns, FaRegBuilding, FaUserCircle, FaUsersCog } from 'react-icons/fa'
import { SidenavItemProps } from '../Korbantech'
import Logo from '../components/logo_impulso.png'
import White_logo from '../components/impulso_branco.png'
import { BsBarChartFill, BsFileEarmarkSlides, BsFlagFill } from 'react-icons/bs'
import { MdEmail } from 'react-icons/md'
import homeBakground from '../assets/fundo home.svg'
import profileBakground from '../assets/fundo meu perfil.svg'
import metricBakground from '../assets/fundo jornada de desenvolvimento.svg'
import contentBakground from '../assets/fundo conteudos.svg'


export const COOKIES_KEYS = {
  admin_access_token: '_impulso_admin_access_token',
  client_access_token: '_impulso_client_access_token'
}

export const MONTHS_SHORT = [
  'jan',
  'fev',
  'mar',
  'abr',
  'mai',
  'jun',
  'jul',
  'ago',
  'set',
  'out',
  'nov',
  'dez'
]


export const WEEK_DAYS = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"]

export const BRAND_LOGO = Logo//"https://institutogrpcom-programaimpulso-site.s3.amazonaws.com/wp-content/themes/impulso/images/impulsopretologo.png"
export const WHITE_LOGO = White_logo

export const ADMIN_MENU_ITEMS:SidenavItemProps[] = [
    {
        label: 'Início',
        to: '/admin',
        icon: AiFillHome
    },
    {
        label: 'Cadastros',
        to: '/admin/osc',
        icon: FaRegBuilding
    },
    {
        label: 'Testes',
        to: '/admin/testes',
        icon: AiFillFileText
    },
    {
        label: 'Trilhas',
        to: '/admin/trilha',
        icon: FaMapSigns
    },
    {
        label: 'Biblioteca',
        to: '/admin/biblioteca',
        icon: AiFillFolder
    },
    {
        label: 'Email',
        to: '/admin/emails',
        icon: MdEmail
    },
    {
        label: 'Relatórios',
        to: '/admin/relatorios',
        icon: BsBarChartFill
    },
    {
        label: 'Slides',
        to: '/admin/slides',
        icon: BsFileEarmarkSlides
    },
    {
        label: 'Usuários admin',
        to: '/admin/admin',
        icon: FaUsersCog
    },
]


export const OSC_MENU_ITEMS:SidenavItemProps[] = [
    {
        label: 'Home',
        to: '/osc',
        icon: AiFillHome,
        img:homeBakground
    },
    {
        label: 'Meu Perfil',
        to: '/',
        icon:FaUserCircle,
        img:profileBakground,
        children:[{
            label:"Desempenho",
            to:"/osc/metricas",
        },
        {
            label:"Cadastro",
            to:"/osc/meu-perfil",
        }]

    },
    {
        label: 'Jornada de Desenvolvimento',
        to: '/osc/jornada',
        icon: BsFlagFill,
        img:metricBakground
    },
    {
        label: 'Conteúdos',
        to: '/osc/biblioteca',
        icon: AiFillFolder,
        img:contentBakground
    },

]
